import { FC } from 'react'
import { Box, Tooltip } from '@mui/material'
import theme from 'theme'
import { AssetColumnKind, AssetRow } from 'models'
import { recordsCellTooltipProps } from 'ui/pages/cpi-details/sections/devices/utils'
import { formatCellValue } from '../utils/assetRows'

interface Props {
  row?: AssetRow
  column: string
  kind: AssetColumnKind
}

/**
 * The operational view's cell, plus the overflow count. `+N` is how many values the cell left out —
 * the cue that a filter matched something this cell does not show.
 */
const AssetCell: FC<Props> = ({ row, column, kind }) => {
  if (!row) return null

  const text = formatCellValue(row.values[column], kind)
  const more = row.badges[column]

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: `${theme.spacing.half}px`, overflow: 'hidden' }}>
      <Tooltip title={text} placement="right" arrow componentsProps={recordsCellTooltipProps}>
        <div
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: theme.colors.menuItemText
          }}
        >
          {text}
        </div>
      </Tooltip>

      {!!more && (
        <Tooltip
          title={`${more} more ${more === 1 ? 'value' : 'values'}`}
          placement="top"
          arrow
          componentsProps={recordsCellTooltipProps}
        >
          <Box
            sx={{
              flexShrink: 0,
              color: theme.colors.textCaption,
              fontFamily: theme.typography.fontFamily.primary,
              fontWeight: theme.typography.fontWeight.normal,
              lineHeight: '20px'
            }}
          >
            +{more}
          </Box>
        </Tooltip>
      )}
    </Box>
  )
}

export default AssetCell
